/* eslint-disable radix */
/* eslint-disable react/no-multi-comp */
/* eslint-disable react/prefer-stateless-function */
import React, { Component } from "react";
import { EditorBlock } from "draft-js";

import { DRAFT, DOCUMENTS } from "../../constants";

const { EDITOR_CUSTOM_STYLES_MAP, EDITOR_BULLET_OFFSET } = DOCUMENTS;

const getStyleList = block => {
  const listReactStyles = {};
  let listStyles = block.data.get("elementStyle") || "";
  if (Object.entries(listStyles).length !== 0) {
    listStyles = listStyles
      .replace("text-align", "textAlign")
      .replace("margin-left", "marginLeft")
      .replace("margin-right", "marginRight")
      .replace("padding-left", "paddingLeft")
      .replace("padding-right", "paddingRight")
      .replace("text-indent", "textIndent")
      .replace("justify-content", "justifyContent")
      .replace("line-height", "lineHeight")
      .replace("font-family", "fontFamily");
    listStyles = listStyles.split(";");
    for (let i = 0; i < listStyles.length; i += 1) {
      const style = listStyles[i];
      const [key, value] = style.split(":");
      listReactStyles[key] = value;
    }
  }
  return listReactStyles;
};

class HeaderOneComponent extends Component {
  render() {
    const listReactStyles = getStyleList(this.props.block);
    return (
      <h1 id="header-one" className="header-one" style={listReactStyles}>
        <EditorBlock {...this.props} />
      </h1>
    );
  }
}

class HeaderTwoComponent extends Component {
  render() {
    const listReactStyles = getStyleList(this.props.block);
    return (
      <h2 id="header-two" className="header-two" style={listReactStyles}>
        <EditorBlock {...this.props} />
      </h2>
    );
  }
}
class HeaderThreeComponent extends Component {
  render() {
    const listReactStyles = getStyleList(this.props.block);
    return (
      <h3 id="header-three" className="header-three" style={listReactStyles}>
        <EditorBlock {...this.props} />
      </h3>
    );
  }
}
class HeaderFourComponent extends Component {
  render() {
    const listReactStyles = getStyleList(this.props.block);
    return (
      <h4 id="header-four" className="header-four" style={listReactStyles}>
        <EditorBlock {...this.props} />
      </h4>
    );
  }
}

class UnStyledParagraph extends Component {
  render() {
    const listReactStyles = getStyleList(this.props.block);
    return (
      <div id="styledpara" className="styledpara" style={listReactStyles}>
        <EditorBlock {...this.props} />
      </div>
    );
  }
}

class ParaListComponent extends Component {
  render() {
    const listReactStyles = getStyleList(this.props.block);
    return (
      <div id="listitem" style={listReactStyles}>
        <EditorBlock {...this.props} />
      </div>
    );
  }
}

const getStylesFromMetaData = metaData => {
  const styles = [];
  if (metaData && Object.keys(metaData) && Object.keys(metaData).length > 0) {
    Object.keys(metaData).forEach(style => {
      if (style !== "BLOCKTYPE") {
        if (style === "BOLD" || style === "ITALIC" || style === "UNDERLINE") {
          styles.push(style);
        } else if (metaData[style]) {
          styles.push(metaData[style]);
        }
      }
    });
  }
  return styles;
};

const getListFirstCharStyles = (block, contentState) => {
  let getStyles = {};
  let firstCharStyles = block.getInlineStyleAt(0).toArray();

  // if the first char's styles are not there, then get styles from the meta data
  if (firstCharStyles && firstCharStyles.length === 0) {
    const nextBlock = contentState.getBlockAfter(block.getKey());
    firstCharStyles = nextBlock ? nextBlock.getInlineStyleAt(0).toArray() : [];
  }

  if (firstCharStyles && firstCharStyles.length > 0) {
    // For old style format, need to get the all styles in a single array
    // (because, some old styles were coming inside an array not a string)
    let styleList = [];
    firstCharStyles.forEach(style => {
      if (typeof style === "string") {
        styleList.push(style);
      } else if (Array.isArray(style)) {
        styleList = [...styleList, ...style];
      }
    });

    styleList.forEach(style => {
      if (typeof style === "string") {
        if (style.startsWith("FONTCOLOR") && !EDITOR_CUSTOM_STYLES_MAP[style]) {
          const getColor = style.split("_")[1];
          if (getColor) {
            getStyles = { ...getStyles, color: `#${getColor}` };
          }
        } else {
          getStyles = { ...getStyles, ...EDITOR_CUSTOM_STYLES_MAP[style] };
        }
      }
    });
  }
  return getStyles;
};

// calculates the offest to add in left margin so that bullet doesnt go outside table/editor
const getMarginLeftOffsetForBulletSize = (
  block,
  listType,
  metaData,
  isCustomTableTextEditor,
) => {
  let marginOffset = 0;
  let firstCharStyles = block.getInlineStyleAt(0).toArray();

  // if the first char's styles are not there, then get styles from the meta data
  if (firstCharStyles && firstCharStyles.length === 0) {
    firstCharStyles = getStylesFromMetaData(metaData);
  }

  if (firstCharStyles && firstCharStyles.length > 0) {
    let styleList = [];
    firstCharStyles.forEach(style => {
      if (typeof style === "string") {
        styleList.push(style);
      } else if (Array.isArray(style)) {
        styleList = [...styleList, ...style];
      }
    });
    styleList.forEach(style => {
      if (typeof style === "string") {
        if (
          isCustomTableTextEditor &&
          style.startsWith("FONTSIZE") &&
          EDITOR_BULLET_OFFSET.TABLE &&
          EDITOR_BULLET_OFFSET.TABLE[listType] &&
          EDITOR_BULLET_OFFSET.TABLE[listType][style]
        ) {
          marginOffset += EDITOR_BULLET_OFFSET.TABLE[listType][style];
        } else if (
          style.startsWith("FONTSIZE") &&
          EDITOR_BULLET_OFFSET.EDITOR[listType] &&
          EDITOR_BULLET_OFFSET.EDITOR[listType][style]
        ) {
          marginOffset += EDITOR_BULLET_OFFSET.EDITOR[listType][style];
        }

        if (
          listType === "ORDERED" &&
          (style === "FONTWEIGHT_EXTRABOLD" ||
            style === "FONTWEIGHT_BOLD" ||
            style === "FONTWEIGHT_SEMIBOLD")
        ) {
          marginOffset += 5;
        }
      }
    });
  }

  return marginOffset > 0 ? marginOffset : 0;
};

class OrderedListComponent extends Component {
  LIST_TYPE = DRAFT.ORDERED_LIST_TYPES;

  render() {
    const { block, contentState } = this.props;
    const listReactStyles = getStyleList(block);

    const type = block.getType();
    // get the list level
    const listLevel = parseInt(type.split("-")[2]);

    // Getting the list's first char styles to apply styles on list type marker
    const firstCharStyles = getListFirstCharStyles(
      this.props.block,
      contentState,
    );

    const listStyleType =
      this.LIST_TYPE[(listLevel - 1) % this.LIST_TYPE.length];

    const { isCustomTableTextEditor } = this.props.blockProps;
    const marginOffset = getMarginLeftOffsetForBulletSize(
      this.props.block,
      "ORDERED",
      this.props.blockProps ? this.props.blockProps.metaData : {},
      isCustomTableTextEditor,
    );
    listReactStyles.marginLeft = `${
      listLevel * DRAFT.DRAFT_TAB_LENGTH - 16 + marginOffset
    }px`;
    let count = 1;
    let prevBlock = contentState.getBlockBefore(block.getKey());

    // count proper
    if (
      prevBlock &&
      prevBlock.getType().includes("list") &&
      type.includes("list")
    ) {
      while (prevBlock && prevBlock.getType().includes("list")) {
        // check if prev level should be continued/discontinued
        if (
          prevBlock &&
          parseInt(prevBlock.getType().split("-")[2]) === listLevel - 1
        ) {
          break;
        }
        if (prevBlock && prevBlock.getType() === type) {
          // get that last count
          count += 1;
        }

        prevBlock = contentState.getBlockBefore(prevBlock.getKey());
      }
    }

    return (
      <ol className={`ordered-list ${type}`} style={listReactStyles}>
        <div className="editor-list-wrapper">
          <li
            style={{
              display: "list-item",
              listStyleType,
              ...firstCharStyles,
            }}
            value={count}
          />
          <li id="ordered-list" className={"revv-list-item"} value={count}>
            <EditorBlock {...this.props} />
          </li>
        </div>
      </ol>
    );
  }
}

class UnorderedListComponent extends Component {
  LIST_TYPE = DRAFT.UNORDERED_LIST_TYPES;

  render() {
    const listReactStyles = getStyleList(this.props.block);
    const type = this.props.block.getType();

    // Getting the list's first char styles to apply styles on list type marker
    const firstCharStyles = getListFirstCharStyles(
      this.props.block,
      this.props.contentState,
    );

    // get the list level
    const listLevel = parseInt(type.split("-")[2]);
    const listStyleType = this.LIST_TYPE[listLevel % this.LIST_TYPE.length];

    const { isCustomTableTextEditor } = this.props.blockProps;
    const marginOffset = getMarginLeftOffsetForBulletSize(
      this.props.block,
      "UNORDERED",
      this.props.blockProps ? this.props.blockProps.metaData : {},
      isCustomTableTextEditor,
    );
    listReactStyles.marginLeft = `${
      listLevel * DRAFT.DRAFT_TAB_LENGTH - 16 + marginOffset
    }px`;
    return (
      <ul className={`unordered-list ${type}`} style={listReactStyles}>
        <div className="editor-list-wrapper">
          <li
            style={{
              display: "list-item",
              listStyleType,
              ...firstCharStyles,
            }}
          />
          <li id="unordered-list" className={"revv-list-item"}>
            <EditorBlock {...this.props} />
          </li>
        </div>
      </ul>
    );
  }
}
const blockTypeMapping = {
  "header-one": HeaderOneComponent,
  "header-two": HeaderTwoComponent,
  "header-three": HeaderThreeComponent,
  "header-four": HeaderFourComponent,
  unstyled: UnStyledParagraph,
  plist: ParaListComponent,
};

const customBlockRenderer =
  (getEditorState, onChange, readOnly, metaData, isCustomTableTextEditor) =>
  contentBlock => {
    const type = contentBlock.getType();
    let component;
    if (type in blockTypeMapping) {
      component = blockTypeMapping[type];
    } else if (type.startsWith("unordered-list")) {
      component = UnorderedListComponent;
    } else if (type.startsWith("ordered-list")) {
      component = OrderedListComponent;
    }
    if (component) {
      return {
        component,
        editable: !readOnly,
        props: {
          onChange,
          getEditorState,
          metaData,
          isCustomTableTextEditor,
        },
      };
    }
    return null;
  };

export default customBlockRenderer;
